export enum GetClientActionTypes {
    REQUEST = '@@client/get-client/request',
    SUCCESS = '@@client/get-client/success',
    ERROR = '@@client/get-client/error'
}

export enum GetClientCouponsActionTypes {
    REQUEST = '@@client/get-coupons/request',
    SUCCESS = '@@client/get-coupons/success',
    ERROR = '@@client/get-coupons/error'
}

export enum GetClientSubsidiesActionTypes {
    REQUEST = '@@client/get-subsidies/request',
    SUCCESS = '@@client/get-subsidies/success',
    ERROR = '@@client/get-subsidies/error'
}

export enum GetCardInfoActionTypes {
    REQUEST = '@@client/get-card-info/request',
    SUCCESS = '@@client/get-card-info/success',
    ERROR = '@@client/get-card-info/error'
}
